import { Box } from "@mui/material"
import React, { useContext } from "react"
import { BOTTOM_NAVIGATION_HEIGHT } from "../../../../../../../../components/buttons/navigate-button/CustomBottomNavigation"
import { BSParkingNoBimContainer } from "../../../building/BSCreateBuildingPages/BSBuildingParkingPage/components/BSParkingNoBimContainer"
import { BSBuildingContext } from "../../../building/components/context/BSBuildingContext"
import { ControlPanelTabHeader } from "../../../components/ControlPanelTabHeader"
import { BSParkingBimContainer } from "../../../building/BSCreateBuildingPages/BSBuildingParkingPage/components/BSParkingBimContainer"

interface IProps {
  isUpdating: boolean
  setIsUpdating: React.Dispatch<React.SetStateAction<boolean>>
}

export function BSParkingTab({ isUpdating, setIsUpdating }: Readonly<IProps>): React.JSX.Element {
  const { selectedBSBuilding } = useContext(BSBuildingContext)

  return (
    <Box
      height={isUpdating ? `calc(100% - ${BOTTOM_NAVIGATION_HEIGHT} -  2vh)` : "100%"}
      px={5}
      pb={2}
      sx={{ overflow: "auto" }}>
      <ControlPanelTabHeader title="Parking" />
      {selectedBSBuilding?.bim ? (
        <BSParkingBimContainer setIsUpdating={setIsUpdating} isUpdating={isUpdating} />
      ) : (
        <BSParkingNoBimContainer />
      )}
    </Box>
  )
}
